export default __webpack_public_path__ + "static/media/Map.ce9c2d34.svg";